import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {Tile} from '@shared/models/tile';
import {TileIcon} from '@shared/models/tile-icon';
import {TileComponent} from '@lib/components/tile/tile.component';
import {BaseDrawerComponent} from '@lib/components/_base-drawer/base-drawer.component';
import {ClickService} from '@core/services/click.service';
import {EscapeKeyService} from '@core/services/escape-key.service';
import {CanvasTileDrawerEntry} from '@features/canvas-tiles/display/models/canvas-tile-drawer.model';

@Component({
  selector: 'motn-canvas-tile-drawer',
  standalone: true,
  templateUrl: './canvas-tile-drawer.component.html',
  styleUrls: ['./canvas-tile-drawer.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    TileComponent,
  ],
})
export class CanvasTileDrawerComponent extends BaseDrawerComponent {
  @Input() set tiles(value: Tile[]) {
    this._tiles = value;
    const seen = new Map<string, number>();
    this.entries = (value ?? []).map(tile => {
      const occurrence = seen.get(tile.ID) ?? 0;
      seen.set(tile.ID, occurrence + 1);
      return {key: `${tile.ID}:${occurrence}`, tile};
    });
  }
  get tiles(): Tile[] {
    return this._tiles;
  }
  entries: CanvasTileDrawerEntry[] = [];

  @Input() displayName: string;
  @Input() displayIcon: TileIcon;

  private _tiles: Tile[];

  constructor(
    protected clickService: ClickService,
    protected escapeKeyService: EscapeKeyService,
  ) {
    super(clickService, escapeKeyService);
  }

  protected onInit(): void {}
}
